import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent } from "@/lib/analytics";

/** Fires PAGE_VIEW on every route change (only if consent granted). */
const AnalyticsRouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    trackEvent("PAGE_VIEW", { path: location.pathname + location.search });
    if (location.pathname === "/signup" || location.pathname === "/login") {
      trackEvent("SIGNUP_PAGE_VIEW", { path: location.pathname });
    }
  }, [location.pathname, location.search]);
  return null;
};

export default AnalyticsRouteTracker;
